"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessibilityText = exports.StyledButtonBase = exports.classes = void 0;
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const styles_1 = require("@mui/material/styles");
const PREFIX = "Thumbnail";
exports.classes = {
    disabled: `${PREFIX}-disabled`,
    selected: `${PREFIX}-selected`,
    large: `${PREFIX}-large`,
    playIcon: `${PREFIX}-playIcon`,
    cubeIcon: `${PREFIX}-cubeIcon`
};
exports.StyledButtonBase = (0, styles_1.styled)(ButtonBase_1.default)(({ theme }) => ({
    display: "inline-block",
    border: `1px solid ${theme.colours.white}`,
    margin: "2px",
    backgroundPosition: "center center",
    backgroundColor: theme.colours.slate,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    width: "60px",
    height: "50px",
    "&:hover": {
        boxShadow: `0 0 0 2px ${theme.colours.inter}50`
    },
    [`&.${exports.classes.disabled}`]: {
        opacity: 0.5,
        "&:hover": {
            boxShadow: "none"
        }
    },
    [`&.${exports.classes.selected}`]: {
        boxShadow: `0 0 0 2px ${theme.colours.accent300}`,
        cursor: "default",
        "&:hover": {
            boxShadow: `0 0 0 2px ${theme.colours.accent300}`,
            cursor: "default"
        }
    },
    [`&.${exports.classes.large}`]: {
        width: "80px",
        height: "60px",
        backgroundSize: "cover"
    }
}));
exports.AccessibilityText = (0, styles_1.styled)("span")(({ theme }) => ({
    textIndent: "-9999px",
    overflow: "hidden",
    display: "inline-block",
    // NOTE: This sets the Ripple's colour
    color: theme.colours.charcoal
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RodW1ibmFpbC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsMEVBQWtEO0FBQ2xELGlEQUE4QztBQUU5QyxNQUFNLE1BQU0sR0FBRyxXQUFXLENBQUM7QUFFZCxRQUFBLE9BQU8sR0FBRztJQUNyQixRQUFRLEVBQUUsR0FBRyxNQUFNLFdBQVc7SUFDOUIsUUFBUSxFQUFFLEdBQUcsTUFBTSxXQUFXO0lBQzlCLEtBQUssRUFBRSxHQUFHLE1BQU0sUUFBUTtJQUN4QixRQUFRLEVBQUUsR0FBRyxNQUFNLFdBQVc7SUFDOUIsUUFBUSxFQUFFLEdBQUcsTUFBTSxXQUFXO0NBQy9CLENBQUM7QUFFVyxRQUFBLGdCQUFnQixHQUFHLElBQUEsZUFBTSxFQUFDLG9CQUFVLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDakUsT0FBTyxFQUFFLGNBQWM7SUFDdkIsTUFBTSxFQUFFLGFBQWEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUU7SUFDMUMsTUFBTSxFQUFFLEtBQUs7SUFDYixrQkFBa0IsRUFBRSxlQUFlO0lBQ25DLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7SUFDcEMsZ0JBQWdCLEVBQUUsV0FBVztJQUM3QixjQUFjLEVBQUUsU0FBUztJQUN6QixLQUFLLEVBQUUsTUFBTTtJQUNiLE1BQU0sRUFBRSxNQUFNO0lBQ2QsU0FBUyxFQUFFO1FBQ1QsU0FBUyxFQUFFLGFBQWEsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLElBQUk7S0FDaEQ7SUFDRCxDQUFDLEtBQUssZUFBTyxDQUFDLFFBQVEsRUFBRSxDQUFDLEVBQUU7UUFDekIsT0FBTyxFQUFFLEdBQUc7UUFDWixTQUFTLEVBQUU7WUFDVCxTQUFTLEVBQUUsTUFBTTtTQUNsQjtLQUNGO0lBQ0QsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxRQUFRLEVBQUUsQ0FBQyxFQUFFO1FBQ3pCLFNBQVMsRUFBRSxhQUFhLEtBQUssQ0FBQyxPQUFPLENBQUMsU0FBUyxFQUFFO1FBQ2pELE1BQU0sRUFBRSxTQUFTO1FBQ2pCLFNBQVMsRUFBRTtZQUNULFNBQVMsRUFBRSxhQUFhLEtBQUssQ0FBQyxPQUFPLENBQUMsU0FBUyxFQUFFO1lBQ2pELE1BQU0sRUFBRSxTQUFTO1NBQ2xCO0tBQ0Y7SUFDRCxDQUFDLEtBQUssZUFBTyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDdEIsS0FBSyxFQUFFLE1BQU07UUFDYixNQUFNLEVBQUUsTUFBTTtRQUNkLGNBQWMsRUFBRSxPQUFPO0tBQ3hCO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLGlCQUFpQixHQUFHLElBQUEsZUFBTSxFQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUM5RCxVQUFVLEVBQUUsU0FBUztJQUNyQixRQUFRLEVBQUUsUUFBUTtJQUNsQixPQUFPLEVBQUUsY0FBYztJQUN2QixzQ0FBc0M7SUFDdEMsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsUUFBUTtDQUM5QixDQUFDLENBQUMsQ0FBQyJ9